/**
 * The department to show next to a member's position, or `undefined` when it adds nothing.
 *
 * `/api/org-hierarchy` currently fills `department` with the user's position, so rendering both
 * printed the same title twice on every org-chart node. Hiding it only when it repeats the position
 * keeps the badge working once the BE sends the real department.
 */
export function distinctDepartment(position?: string, department?: string): string | undefined {
  const dept = department?.trim();
  if (!dept) return undefined;
  return dept.toLowerCase() === position?.trim().toLowerCase() ? undefined : dept;
}
